<template>

  <div class="container p-0">
    <div v-bind:class="{ 'standard-search': true, 'advanced-search-isScrolled': isScrolled, 'job-cdljn-search': cdljnSearch }" class="block md:flex md:justify-between">

      <div class="vx-card" v-click-outside="hideZipInputOnMobile">

          <div class="company">

            <vs-icon
                color="primary"
                icon-pack="feather"
                icon="icon-search"></vs-icon>

            <form v-if="showKeywordInput" autocomplete="off" @submit.prevent="submitSearch">
              <autocomplete
                id="keyword"
                :minLength="1"
                :prepopulateChosen="keywordInput"
                :placeholder="keywordsPlaceholder"
                @onSubmit="submitSearch(1)"
                @onSelect="onKeywordsSelect"
                @onInput="onKeywordsSelect"
                :apiCall="keywordsApiCall"
                @onFocusVueSuggest="showZipInputOnMobile(true)"
              />
            </form>

            <form v-else autocomplete="off" @submit.prevent="submitSearch">
              <autocomplete
                  id="location"
                  use-postal-code
                  :minLength="1"
                  :prepopulateChosen="primaryLocation"
                  :placeholder="cityPlaceholder"
                  @onSubmit="submitSearch(1)"
                  @onSelect="onSelect"
                  @onInput="onSelect"
                  :apiCall="locationApiCall"
              />
            </form>

            <div class="filter_with_badge">

              <span
                class="badge"
                v-if="hasFilterSelected !== 0"
                v-text="hasFilterSelected"
                >
              </span>

              <vs-button
                color="rgb(var(--colors-white))"
                type="flat"
                class="mobile_filter"
                @click="showFilters(true)"
                :class="{'filterIsActive': hasFilterSelected !== 0 }"
              >

               <svg class="mobileFilterIcon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="rgb(var(--colors-green-500))" fill-rule="evenodd" d="M9.01 15.351c1.237 0 2.289.864 2.619 2.045h7.608c.433 0 .763.337.763.78 0 .442-.35.78-.763.78H11.63C11.299 20.136 10.247 21 9.01 21c-1.237 0-2.288-.864-2.618-2.044h-1.63c-.432 0-.762-.338-.762-.78 0-.443.35-.78.763-.78h1.629c.33-1.18 1.381-2.045 2.618-2.045zm0 1.56c-.7 0-1.237.548-1.237 1.265 0 .716.578 1.264 1.237 1.264.66 0 1.237-.548 1.237-1.264 0-.717-.536-1.265-1.237-1.265zm6.042-7.735c1.178 0 2.188.783 2.566 1.878l.052.166h1.567c.433 0 .763.358.742.78 0 .406-.294.723-.66.773l-.103.007H17.65c-.33 1.18-1.381 2.044-2.618 2.044-1.178 0-2.188-.783-2.567-1.878l-.052-.166h-7.65C4.33 12.78 4 12.422 4 12c0-.406.295-.723.661-.773l.102-.007h7.65c.35-1.16 1.401-2.044 2.639-2.044zm0 1.56c-.701 0-1.238.547-1.238 1.264s.578 1.265 1.238 1.265 1.237-.548 1.237-1.265c0-.717-.536-1.265-1.237-1.265zM9.01 3c1.179 0 2.188.784 2.567 1.878l.052.166h7.608c.433 0 .763.338.763.78 0 .406-.295.723-.661.773l-.102.007H11.63c-.33 1.18-1.382 2.045-2.619 2.045-1.178 0-2.188-.784-2.566-1.878l-.052-.167h-1.63c-.432 0-.762-.337-.762-.78 0-.405.295-.723.661-.773l.102-.007h1.629C6.722 3.864 7.773 3 9.01 3zm0 1.56c-.66 0-1.237.59-1.237 1.264 0 .675.536 1.265 1.237 1.265.701 0 1.237-.548 1.237-1.265 0-.716-.577-1.264-1.237-1.264z"/>
              </svg>

              </vs-button>
            </div>

            <primary-button
              class="mobile_search"
              @click="submitSearchMobileReset"
            >

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="rgb(var(--colors-white))" fill-rule="evenodd" d="M20.726 19.46l-4.047-4.052c.492-.619.885-1.344 1.18-2.174.296-.83.443-1.695.443-2.595 0-1.055-.204-2.047-.611-2.975-.394-.929-.938-1.738-1.634-2.427-.695-.69-1.507-1.238-2.434-1.646C12.696 3.197 11.705 3 10.65 3s-2.044.197-2.972.59C6.752 4 5.94 4.548 5.245 5.238c-.696.69-1.24 1.498-1.634 2.427C3.204 8.592 3 9.584 3 10.639c0 1.07.204 2.068.611 2.996.394.929.938 1.738 1.634 2.427.695.69 1.507 1.238 2.434 1.646.928.394 1.918.59 2.972.59.9 0 1.75-.147 2.55-.442.801-.296 1.539-.69 2.214-1.182l4.046 4.052c.099.098.208.168.327.21.12.043.221.064.306.064.084 0 .186-.021.305-.063.12-.043.229-.113.327-.211.183-.183.274-.394.274-.633 0-.24-.091-.45-.274-.633zM4.813 10.639c0-.802.147-1.562.442-2.28.31-.703.727-1.321 1.254-1.856.527-.535 1.15-.95 1.866-1.245.702-.31 1.461-.464 2.276-.464.815 0 1.574.154 2.276.464.717.295 1.339.71 1.866 1.245.527.535.945 1.153 1.254 1.857.295.717.442 1.477.442 2.279 0 .816-.147 1.576-.442 2.279-.295.703-.717 1.33-1.265 1.878-.534.535-1.152.953-1.855 1.256-.702.302-1.461.453-2.276.453-.815 0-1.574-.154-2.276-.464-.717-.31-1.339-.728-1.866-1.256-.527-.527-.945-1.15-1.254-1.867-.295-.703-.442-1.463-.442-2.28z"/>
          </svg>

            </primary-button>

          </div>

          <div class="zip city_state_zip relative" ref="zip">

            <vs-icon
              color="primary"
              icon-pack="feather"
              icon="icon-map-pin"></vs-icon>

            <form autocomplete="off" @submit.prevent="submitSearch">
              <autocomplete
                  id="location"
                  use-postal-code
                  :minLength="1"
                  :prepopulateChosen="primaryLocation"
                  :placeholder="cityPlaceholder"
                  @onSubmit="submitSearch(1)"
                  @onSelect="onSelect"
                  @onInput="onSelect"
                  :apiCall="locationApiCall"
              />
            </form>

            <template v-if="hasLocationError">
              <div
                      class="absolute"
                      style="border: 1px solid rgb(var(--colors-red-500)); border-radius: 12px; left: 15px; top: 15px; right: 15px; bottom: 15px; pointer-events: none; z-index: 0;"
              ></div>
              <div class="absolute" style="color: rgb(var(--colors-red-500)); pointer-events: none; z-index: 999; bottom: 0; left: 20px;">Please enter a valid zip code</div>
            </template>

          </div>

          <div class="no-right-border scrollH">

            <div class="gradient absolute h-full" v-show="filterIsScrollable && filterIsScrolledLeft"></div>

            <div class="scroll-nav flex w-full overflow-y-hidden overflow-x-auto flex-no-wrap" ref="filterNav" v-resize="checkIfOverflowing">
              <div ref="filterNavSelectInput">
                <SelectInput
                  v-for="(option, index) in filterOptions"
                  :key="index"
                  :filterName="option.model"
                  :placeholder="option.model"
                  :inputDisabled="option.inputDisabled"
                  :options="option"
                  @selectedOption="onChange"
                  @submitFilters="submitSearch"
                  v-if="isFilterVisible(index) && (index !== 'radius')"
                />
              </div>
            </div>

            <div class="gradient absolute right h-full" v-show="filterIsScrollable && filterIsScrolledRight"></div>

          </div>


          <div class="no-right-border search_btn_lg">

            <primary-button @click="submitSearch(1)" title="Search">Search</primary-button>

          </div>

      </div>

    </div>

    <div class="form_filter block text-justify w-full fixed h-screen" v-if="filterFormIsOpen === true">
      <div class="mobile-max-height overflow-y-auto overflow-x-hidden">
        <div class="block">
          <div class="flex items-center">
            <div @click="showFilters(false)" class="back-btn inline-flex items-center cursor-pointer">
              <vs-icon
                color="secondary"
                icon-pack="feather"
                icon="icon-chevron-left"></vs-icon>
              <span>Back</span>
            </div>
            <div class="inline-flex justify-center">
              <span class="font-bold">Filters</span>
            </div>

        </div>
        </div>

        <div class="main-filter">
          <template v-for="(filterOption, index) in filterOptions" >

            <div :key="index" v-if="isFilterVisible(index) && (index !== 'radius')"
                 :ref="`optionsWrapperMobile${filterOption.name}`"
                 :class="{ [filterOption.class || '']: true }"
                 :style="filterOption.styling"
            >

              <p class="head-text">{{ filterOption.model }}</p>

              <div
                v-for="(value, i) in filterOption.value"
                :key="i"
                class="flex"
              >
                <vs-radio
                        color="primary"
                        v-model="filterOptions[index].selected"
                        v-if="isRadioOption(filterOption)"
                        :vs-value="value.id"
                        :vs-name="filterOption.model + '-' +i"
                        :key="filterOption.model + '-' +i"
                >
                  {{ value.option }}
                </vs-radio>

                <div v-else-if="isRadioToggleOption(filterOption)" class="custom-checkbox space-x-2 toggle-radio">
                  <input type="radio" name="radio" v-model="filterOptions[index].selected" :value="value.id" :id="value.id" @click="toggleRadio(value.id, index)" class="cursor-pointer">

                  <label :for="value.id" class="text-onyx-light cursor-pointer text-14" >
                    {{ value.option }}
                  </label>
                </div>

                <vs-checkbox
                        color="primary"
                        @input="selectAll( index )"
                        :checked="isAllSelected(index)"
                        v-else-if="(value.id || value.option).toString() == '0'"
                        icon-pack="feather"
                        icon="icon-check"
                        :vs-value="(value.id || value.option).toString()"
                        :disabled="checkboxDisabled(value, index)"
                >
                  {{ value.option }}
                </vs-checkbox>

                <vs-checkbox
                  color="primary"
                  v-model="filterOptions[index].selected"
                  v-else
                  icon-pack="feather"
                  icon="icon-check"
                  :vs-value="(value.id || value.option).toString()"
                  :disabled="checkboxDisabled(value, index)"
                >
                  {{ value.option }}
                </vs-checkbox>
              </div>
            </div>
            <template v-if="filterOption.showMoreButton === true">
              <button :key="index+'_show_more'"
                      v-if="isShowMoreBtn(filterOption.name)"
                      class="mt-4 text-sm text-primary-darker cursor-pointer bg-transparent border-0"
                      @click="toggleMoreBtnClicked(filterOption.name, filterOption.value.length)"
              >
                Show More <simple-svg src="../../../images/icons/chevron-down.svg" />
              </button>
              <button :key="index+'_show_less'"
                      v-else
                      class="mt-4 text-sm text-primary-darker cursor-pointer bg-transparent border-0"
                      @click="toggleMoreBtnClicked(filterOption.name, filterOption.value.length)"
              >
                Show Less <simple-svg style="transform: rotate(180deg);" src="../../../images/icons/chevron-down.svg" />
              </button>
            </template>
          </template>

        </div>
        <div class="h-40px">&nbsp;</div>
        <primary-button
          class="filter-update-btn"
          @click="submitSearchMobile"
        >Update</primary-button>

      </div>

    </div>

  </div>

</template>

<script>
import SelectInput from "./select-input/SelectInput";
import throttle from 'lodash/throttle';
import ResizeObserver from "resize-observer-polyfill"
import queryBuilder from "../utilities/querybuilder"
import CCRequestInputMixin from "../mixins/CCRequestInputMixin";
import QueryParameters from "../utilities/queryparameters";
import HandleSearchScrollMixin from "../mixins/HandleSearchScrollMixin";
import MoreButtonMixin from "../mixins/MoreButtonMixin";

export default {
  name: "advanced-search",
  mixins: [
    CCRequestInputMixin,
    HandleSearchScrollMixin,
    MoreButtonMixin
  ],
  components: {
    SelectInput
  },

  props: {
    hasLocationError: {
      type: Boolean,
      default: false,
    },
    keywordsApiCall: {
        type: String,
        default: ''
    },
    locationApiCall: {
        type: String,
        default: ''
    },
    prepopulateCity: {
        type: String,
        default: ''
    },
    keywordsPlaceholder: {
        type: String,
        default: "Job title, keywords or company"
    },
    cityPlaceholder: {
      type: String,
      default: "City, state or zip"
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    jobTypes: {
      type : Array,
      default : () => { return []}
    },
    companies: {
      type : Array,
      default : () => { return []}
    },
    categories: {
      type : Array,
      default : () => { return []}
    },
    urlJobs: {
        type: String,
        required: true
    },
    userFilterOptions: {},
    hideFilters: {
        type: Object,
        default: () => { return {}; }
    },
    locationState: {
      type : String,
    },
    locations : {
      type : Array,
      default : () => []
    },
    experiences: {
      type : Array,
      default : () => { return []}
    },
    routeTypes: {
      type : Array,
      default : () => { return []}
    },
    driverTypes: {
      type : Array,
      default : () => { return []}
    },
    licenseTypes: {
      type : Array,
      default : () => { return []}
    },
    cdljnSearch: {
      type: Boolean,
      default: false
    },
    showKeywordInput: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedFilters: [],
      radioOptions: {
        radius: '',
        job: '',
        location: '',
      },
      filterFormIsOpen: false,
      filterOptions: {
        radius: {
          type: 'Radio',
          toggleRadio: false,
          value: [
            { option: "Exact location only", id: "1" },
            { option: "Within 5 miles", id: "5" },
            { option: "Within 10 miles", id: "10" },
            { option: "Within 15 miles", id: "15" },
            { option: "Within 25 miles", id: "25" },
            { option: "Within 50 miles", id: "50" },
          ],
          model: 'Radius',
          name:'radius',
          initValue: this.userFilterOptions.radius,
          selected : this.userFilterOptions.radius,
          inputDisabled: this.userFilterOptions.inputDisabled.radius
        },
        routeType: {
          model: 'Route Type',
          name: 'routeType',
          value: [
            {option: 'All', id: '0'},
          ].concat(this.routeTypes.map(route => ({ option: `${route.name}`, id: route.id.toString() }))),
          type: 'checkbox',
          initValue: this.getInitialCategoriesByType('routeType'),
          selected: this.getInitialCategoriesByType('routeType'),
          selectType: 'multi',
          inputDisabled: this.userFilterOptions.inputDisabled.routeType
        },
        driverType: {
          model: 'Driver Type',
          name: 'driverType',
          value: [
            {option: 'All Driver Types', id: '0'}
          ].concat(this.driverTypes.map(driver_type => ({ option: `${driver_type.name}`, id: driver_type.id.toString() }))),
          type: 'checkbox',
          initValue: this.getInitialCategoriesByType('driverType'),
          selected: this.getInitialCategoriesByType('driverType'),
          selectType: 'multi',
          inputDisabled: this.userFilterOptions.inputDisabled.driverType
        },
        licenseType: {
          model: 'License Type',
          name: 'licenseType',
          value: [
            {option: 'All License Types', id: '0'}
          ].concat(this.licenseTypes.map(license => ({ option: `${license.name}`, id: license.id.toString() }))),
          type: 'checkbox',
          initValue: this.getInitialCategoriesByType('licenseType'),
          selected: this.getInitialCategoriesByType('licenseType'),
          selectType: 'multi',
          inputDisabled: this.userFilterOptions.inputDisabled.licenseType
        },
      },
      jobInput: this.userFilterOptions.search_text,
      primaryLocation : this.prepopulateCity,
      zipCodeInput: "",
      zipInputDisplayed : true,
    };
  },

  directives: {
    resize: {
      inserted(el, args) {
        if (typeof process === "undefined" || !process.server) {
          const handleResize = throttle((entries) => {

            args.value(entries);

          }, 500)

          const observer = new ResizeObserver(handleResize)
          observer.observe(el)
        }
      }
    }
  },


  computed: {
    isFilterVisible() {
        return (filter) => {
            return (
                this.hideFilters[filter] == undefined ||
                this.hideFilters[filter] === false
            )
        };
    },
      /*
       * @return {number}
       */
    hasFilterSelected: function() {
      return Object.keys(this.filterOptions).reduce( (accFilters, filterKey) => {
          let filterCount = 0;
          if (Array.isArray(this.filterOptions[filterKey].selected)) {
              filterCount = this.filterOptions[filterKey].selected.includes('0') ?
                  this.filterOptions[filterKey].selected.length - 1 :
                  this.filterOptions[filterKey].selected.length;
          }else {
              if( filterKey === 'radius' ){
              } else {
                  filterCount = this.filterOptions[filterKey].selected ? 1 : 0;
              }
          }
          accFilters += filterCount;
          return accFilters;
      }, 0);
    },
    keywordInput : {
          get(){
              if( ! this.zipInputDisplayed ) {
                  if(this.jobInput && this.primaryLocation) {
                      return this.jobInput + ' in '+ this.primaryLocation;
                  }
                  if(this.primaryLocation){
                      return this.primaryLocation;
                  }
              }
              return this.jobInput;
          },
          set( keyword) {
              this.jobInput = keyword;
          }
      }
  },

  watch: {
    radioOptions: {
      handler: function(val) {
        this.selectedFilters = Object.values(val).filter(Boolean);
      },
      deep: true
    }
  },

  methods: {
    isRadioOption(filter) {
      return filter.type === 'Radio' && !filter.toggleRadio
    },
    isRadioToggleOption(filter) {
      return filter.type === 'Radio' && filter.toggleRadio
    },
    toggleRadio(value, index) {
      if (this.filterOptions[index].selected.includes(value)) {
        this.filterOptions[index].selected = '';
      }
    },
    getInitialCategoriesByType(arrType) {
      let firstArr = [];
      let secondArr = JSON.parse(this.userFilterOptions[ QueryParameters.CATEGORIES ] || null);

      switch (arrType){
        case 'routeType': firstArr = this.routeTypes;break;
        case 'licenseType': firstArr = this.licenseTypes;break;
        case 'driverType': firstArr = this.driverTypes;break;
      }

      if(secondArr) {
        let intersectingArr = firstArr.filter(x => secondArr.includes(`${x.id}`));

        return intersectingArr.map(x => `${x.id}`) ;
      }else {
        return [];
      }
    },
    checkboxDisabled(value, option) {
      let selected = [...this.filterOptions[option].selected];
      let valueOptionsLength = this.filterOptions[option].value.length;
      let isSingleSelect = this.filterOptions[option].selectType === 'single';

      if(selected && selected.length > 0 && isSingleSelect) {
        // if all is selected disable the rest else disable rest if not selected
        return (valueOptionsLength - selected.length === 1) ? selected.includes(value.id) : !selected.includes(value.id);
      }else {
        return false;
      }
    },
    submitSearchMobileReset() {
      this.showFilters(false);
      this.submitSearch(1);
    },
    submitSearchMobile(){
      this.showFilters(false);
      this.submitSearch();
    },
    selectAll( option ) {
      let selected = [];
      if( ! this.isAllSelected(option) ) {
        this.filterOptions[option].value.forEach( value => {
          if(value.id !== "0") {
            selected.push( value.id.toString() )
          };
        });
      }
      this.filterOptions[option].selected = [...selected];
    },
    isAllSelected( option ){
          let selected = [...this.filterOptions[option].selected];
          let index = selected.indexOf('0');
          if(index > -1 ){
              selected.splice(index, 1);
          }
          return selected.length >= this.filterOptions[option].value.length - 1
    },
    onKeywordsSelect( val ) {
        this.keywordInput = val;
    },
    onSelect(val) {
        this.primaryLocation = val;
    },
    submitSearch(submitFrom = 0){
      let params = {};

      if (submitFrom === 0) {
        Object.keys(this.filterOptions).forEach( (optKey) => {
            if (this.isFilterVisible(optKey)) {
              const opt = this.filterOptions[optKey];

              if (Array.isArray(opt.selected) ) {
                  if( (opt.selected.length > 0) ) {
                      if (opt.type === 'Radio') {
                        params[opt.name] = opt.selected[0];
                      }else {
                        if(['routeType', 'driverType', 'licenseType'].includes(opt.name)) {
                          if(Array.isArray(params[QueryParameters.CATEGORIES])) {
                            params[QueryParameters.CATEGORIES] = [...new Set([...params[QueryParameters.CATEGORIES], ...opt.selected])];
                          }else {
                            params[QueryParameters.CATEGORIES] = opt.selected;
                          }
                        }else {
                          params[opt.name] = opt.selected;
                        }
                      }
                  }
              }
              else {
                  if( opt.selected ) {
                      params[opt.name] = opt.selected;
                  }
              }
            }
        });
      }else {
          if (this.prepopulateCity === this.primaryLocation) {
            // only send radius if selected
            const radius = this.filterOptions['radius'].selected;
            params[ this.filterOptions['radius'].name ] = Array.isArray( radius ) ? radius[0] : radius;
          }
      }

      params.primary_location = this.primaryLocation;

      if( this.jobInput ) {
          params.search_text = this.jobInput;
      }

      let parsedParams = [];

      Object.keys(params).forEach( param => {
          switch (param){
              case 'search_text': parsedParams[ QueryParameters.KEYWORD ] = encodeURIComponent(params[ param ]);break;
              case 'primary_location': parsedParams[ QueryParameters.PRIMARY_LOCATION ] = params[ param ];break;
              case 'radius': parsedParams[ QueryParameters.RADIUS ] = params[ param ];break;
              case 'jobType': parsedParams[ QueryParameters.JOB_TYPE ] = params[ param ];break;
              case 'category': parsedParams[ QueryParameters.CATEGORIES ] = params[ param ];break;
              default: parsedParams[ param ] = params[param];break;
          }
      })

      window.location = this.routeParsed(this.urlJobs, queryBuilder.buildQueryString( parsedParams ));
    },

    onChange( name, value ) {
      if( Array.isArray(value) ) {
        this.filterOptions[name].selected = (name === 'location' ? value[0] : [ ...value ]);
      }else {
        this.filterOptions[name].selected = [ value ];
      }
      this.checkIfOverflowing();
    },

    checkIfOverflowing(e) {
      var element = this.$refs.filterNav;
      if (element) this.filterIsScrollable = (element.clientWidth < element.scrollWidth);
    },

    showZipInputOnMobile(value) {
      if (window.innerWidth < 1024) {
        this.zipInputDisplayed = value;
        if (this.$refs.zip)
            this.$refs.zip.style.display = value == true ? "flex" : "none";
      }
    },

    showFilters(value) {
      this.filterFormIsOpen = value;

      if (this.DOMBody) {
          this.DOMBody.style.overflowY = value === true ? 'hidden' : 'visible';
      }
    },

    hideZipInputOnMobile() {
      this.showZipInputOnMobile(false);
    },
  },

  mounted() {
    this.$refs.filterNav.addEventListener("scroll", this.filterNavScrolled);
    this.filterNavScrolled();

    this.$nextTick(() => {
        this.hideZipInputOnMobile();
    });
  },
};
</script>

<style lang="scss" scoped>
.job-cdljn-search {
  & .vs-icon-primary {
    color: var(--primary-darker) !important;
  }

  .vx-card {
    & .company {
      & svg.mobileFilterIcon path {
        fill: var(--primary-darker) !important;
      }
    }
  }
}

.mobile-max-height {
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
}

.vx-card {
  @media (min-width: 1024px) {
    max-height: 64px !important;
  }
}

.form_filter {
  max-width: 100vw !important;
  top: 0;
  left: 0;
  z-index: 499999;
  background: var(--white);
  padding: 16px;

  & > div {
    & > div:nth-child(1) {
      margin-bottom: 31px;

      & > div {
        & .back-btn {
          margin-left: -8px;
          font-size: 16px;
          font-family: "Montserrat", serif;
          color: var(--onyx);

          & > i {
            font-size: 24px;
            margin-right: 6px;
          }

          & + div {
            width: 100%;

            & span {
              transform: translateX(-50%);
              font-size: 18px;
              font-family: "Montserrat", serif;
            }
          }
        }
      }
    }
  }

  & .main-filter {
    & > div {
      &.location-filter {
        max-height: 200px;
        overflow: scroll;
      }

      &:not(:last-child) {
        padding-bottom: 22px;
        border-bottom: 1px solid var(--chrome-lightest);
      }

      &:not(:first-child) {
        margin-top: 24px;
      }

      p.head-text {
        color: var(--onyx);
        font-family: "Montserrat", serif;
        font-size: 21px;
        height: 25px;
        margin-bottom: 8px;

        & ~ div {
          height: 42px;
          margin: 0;

          .con-vs-checkbox {
            margin-left: 0;
          }
        }
      }
    }
  }

  & .filter-update-btn {
    font-size: 16px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 320px;
    margin: 24px auto 5px;
    height: 48px;
  }
}

.container {
  @media (min-width: 1024px) {
    max-width: unset;
  }

  @media (min-width: 1280px) {
    display: flex;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }

  .vx-card {
    border-radius: 1rem !important;
    min-height: 64px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: var(--shadow-color-darkest);
    transition: padding 0.5s ease-in-out;

    @media (min-width: 1024px) {
      flex-direction: row;
      padding: 0 12px 0 16px;

      button {
        font-size: 14px;
        font-weight: 500;
        padding: 11px 22.5px !important;
      }
    }

    & .company {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
      width: 100%;

      & svg.mobileFilterIcon path {
        fill: var(--primary);
      }

      & .mobile_search {
        svg {
          transform: translateY(30%);
          margin-top: -50%;
        }
      }

      @media (min-width: 1024px) {
        width: unset;
        border-right: 1px solid var(--chrome-lightest);
        min-width: 277px;
      }

      & i {
        display: none;
        font-size: 21px;

        @media (min-width: 1024px) {
          flex-direction: row;
          display: inline-flex;
        }
      }

      & > input,
      > form {
        margin-left: 15px;
        height: 40px;
        width: 100%;
        flex: 1;
        border: none;
        font-family: "Montserrat", serif;
        font-size: 14px;
        color: var(--onyx-lightest);

        @media (min-width: 1024px) {
          font-family: "Montserrat", serif;
          font-size: 14px;
          margin-left: 8px;
          margin-right: 25px;
        }

        @media (min-width: 1280px) {
          width: 218px;
        }
      }

      & > .filter_with_badge {
        position: relative;

        & > .filterIsActive {
          background-color: var(--lunar) !important;
        }

        & > .badge {
          position: absolute;
          top: -13%;
          right: 4%;
          height: 20px;
          width: 20px;
          background-color: var(--primary-darker);
          font-size: 12px;
          color: var(--white);
          border-radius: 50%;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;

          @media (min-width: 1024px) {
            display: none;
          }
        }

        & > .mobile_filter {
          display: block;
          & svg {
            transform: translateY(30%);
            margin-top: -50%;
          }
          @media (min-width: 1024px) {
            display: none;
          }
        }
      }
    }
    .zip {
      height: 64px;
      width: 100%;
      display: none;
      align-items: center;
      border-top: 1px solid var(--chrome-lightest);
      z-index: 12;

      @media (min-width: 1024px) {
        display: flex;
        width: 212px;
        border-top: none;
        border-right: 1px solid var(--chrome-lightest);
      }

      & > input,
      > form {
        margin-left: 16px;
        height: 40px;
        width: 100%;
        margin-right: 12px;
        border: none;
        font-family: "Montserrat", serif;
        font-size: 14px;
        color: var(--onyx-lightest);

        @media (min-width: 1024px) {
          width: 112px;
          margin-right: 2rem;
          margin-left: 8px;
        }

        @media (min-width: 1280px) {
          width: 100%;
        }
      }
      & i {
        display: none;

        @media (min-width: 1024px) {
          display: inline-flex;
          margin-left: 15px;
          font-size: 20px;
        }

        @media (min-width: 1280px) {
          margin-left: 15px;
        }
      }
    }

    %mobile {
      height: 40px;
      width: 40px;
      padding: 0 !important;
      border-radius: 8px;
      display: inline-flex;
      justify-content: center;

      @media (min-width: 1024px) {
        display: none;
      }
    }

    .mobile {
      &_search {
        @extend %mobile;
        align-items: center;
        margin-right: 12px;
      }

      &_filter {
        @extend %mobile;
        margin: 0 8px;
      }
    }

    & > div.no-right-border {
      display: none;

      @media (min-width: 1024px) {
        display: flex;
        align-items: center;

        & div.custom-chip {
          box-sizing: border-box;
          margin-left: 24px;
          margin-right: 16px;
          height: 40px;
          min-width: 156px;
          border-radius: 6px;
          background-color: var(--primary-lighter);
          align-self: center;
          display: flex;
          justify-content: center;
          align-items: center;
          color: var(--onyx-lightest);
          font-size: 14px;
          padding: 0 6px 0 12px;

          & > div {
            width: 100%;
            display: inline-flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
}

.advanced-search-isScrolled {
  width: 100% !important;
  position: fixed !important;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  transition: all 0.5s ease-in-out;

  @media (min-width: 1024px) {
    width: 100% !important;
    box-sizing: border-box;
  }

  & .vx-card {
    width: 100% !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;

    @media (min-width: 1280px) {
      display: flex;
      padding: 0 40px;
    }
  }
}

.scrollH {
  padding-left: 12px;
  max-width: 700px;
  display: flex;
  position: relative;
  height: 100%;

  & > * {
    flex: 0 0 auto;
  }

  .scroll-nav {
    z-index: 50;
    -ms-overflow-style: none; /* Edge */
    scrollbar-width: none; /* Firefox */

    & > * {
      flex: 0 0 auto;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .gradient {
    pointer-events: none;
    z-index: 100;
    width: 53px;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(
      to right,
      var(--white) 0%,
      rgba(255, 255, 255, 0) 100%
    );

    &.right {
      left: auto;
      right: 0;
      transform: rotate(-180deg);
    }
  }

  @media (min-width: 1024px) {
    min-width: 89px;
  }

  @media (min-width: 1280px) {
    flex: 2 !important;
    max-width: 67%;
    margin-right: 22px;
  }
}

.location-scroll-container {
  transition: height 150ms ease-out;
  border-bottom: 0 !important;
}

.toggle-radio {
  & input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    border: 2px solid rgb(180, 180, 180);
    transition: 0.1s all linear;
  }

  & input:checked {
    background-color: var(--primary);
    border-color: var(--primary);
  }
}
</style>
